import React from 'react';
import {MDBContainer,} from "mdb-react-ui-kit";
import "../css/servicesfont.css";
const StartPractice = () => {
    return (
        <MDBContainer fluid className="p-0">
        <div className="container py-5">
            <div className="row justify-content-center">
              <div className="col-12">
                  <div className="section-title text-center mb-4 pb-2">
                      <h1 className="title mb-4 display-heading AcerhealthTextPurple fomtsizetest" style={{fontFamily:'Lora, serif'}}>Contracts and Compliance</h1>
                      <p className="para-desc mx-auto mb-0" style={{ fontSize: '20px', fontFamily: 'Alegreya Sans', fontWeight: '500' ,textAlign:'justify'}}>
                        At AcerHealth, our <b>Contracts and Compliance </b>services are designed to support your medical practice with expert 
                        management of provider agreements and regulatory adherence. Navigating complex healthcare contracts can be time-consuming,
                         but our team ensures streamlined processes to save you valuable time and resources. We integrate <b>medical billing compliance 
                         services </b>with contract management to minimize risks and maintain full regulatory compliance. Partner with us for reliable 
                         <a
                            href="https://acerhealth.com/services/medical-billing-services"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
              medical billing outsourcing
                        </a>  
                       
                           that aligns with your
                            <a
                            href="https://acerhealth.com/services/revenue-cycle-management"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
             revenue cycle management
                        </a>    goals, ensuring predictable reimbursements and reduced denials. 
                          Trust AcerHealth to keep your practice compliant, efficient, and financially healthy.</p>
                  </div>
              </div>
          </div>
        </div>    
        </MDBContainer>
    );
};
export default StartPractice;



